import { render, staticRenderFns } from "./Fluidcoins.vue?vue&type=template&id=25e02313&scoped=true&"
import script from "./Fluidcoins.vue?vue&type=script&lang=js&"
export * from "./Fluidcoins.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e02313",
  null
  
)

export default component.exports